(function () {
  if (window.HFAtcFeedback) return;

  var DURATION = 3000;

  function getMode() {
    return (window.theme && window.theme.atcAction) || 'open_cart';
  }

  function isSuccessMode() {
    return getMode() === 'success_message';
  }

  function updateCartBubble(sections) {
    if (!sections) return;
    ['cart-icon-bubble', 'cart-live-region-text'].forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;
      var target = document.getElementById(id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector('.shopify-section') || doc.body;
      if (!source) return;
      var dst = target.querySelector('.shopify-section') || target;
      dst.innerHTML = source.innerHTML;
    });
  }

  function showFeedback(button, kind) {
    if (!button) return;
    if (button._hfAtcTimer) clearTimeout(button._hfAtcTimer);
    button.setAttribute('data-hf-atc-state', kind);
    button._hfAtcTimer = setTimeout(function () {
      button.removeAttribute('data-hf-atc-state');
      button._hfAtcTimer = null;
    }, DURATION);
  }

  window.HFAtcFeedback = {
    isSuccessMode: isSuccessMode,
    getMode: getMode,
    showSuccess: function (button) { showFeedback(button, 'success'); },
    showError: function (button) { showFeedback(button, 'error'); },
    updateCartBubble: updateCartBubble
  };
})();
